export default function P({ children }) {
  return (
    <p className="xs:text-lg leading-loose xs:leading-loose max-w-3xl mx-auto mb-6 lg:mb-10">
      {children}
    </p>
  )
}
